import { render, staticRenderFns } from "./OutboundHome.vue?vue&type=template&id=4bdc70ef&scoped=true&"
import script from "./OutboundHome.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OutboundHome.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./OutboundHome.vue?vue&type=style&index=0&id=4bdc70ef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc70ef",
  null
  
)

export default component.exports